"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodedLS = void 0;
const common_1 = require("./common");
const strings_1 = require("./strings");
exports.encodedLS = {
    getItem(key) {
        let data = localStorage.getItem(key);
        if (!data)
            return null;
        const [error, parsed] = (0, common_1.jsonParse)((0, strings_1.decodeString)(data));
        if (!error)
            return parsed;
        return (0, common_1.secureDataType)(data);
    },
    setItem(key, value) {
        localStorage.setItem(key, (0, strings_1.encodeString)(JSON.stringify(value)));
    },
    removeItem(key) {
        localStorage.removeItem(key);
    },
};
